var _defs, _rect, _rect2, _polygon, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartsignalsPicturemark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Background",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.93 24.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-smasi-1 {\n        fill: #ed6a32 !important;\n      }\n\n      .cls-smasi-2 {\n        fill: #e7b8a7 !important;\n      }\n\n      .cls-smasi-3 {\n        fill: #923c21 !important;\n      }\n\n      .cls-smasi-4 {\n        fill: #c0542b !important;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-smasi-3",
    x: 0,
    y: 17.71,
    width: 6.32,
    height: 6.32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-smasi-4",
    x: 8.8,
    y: 8.85,
    width: 6.32,
    height: 15.18
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-smasi-2",
    points: "15.17 0 6.32 0 0 0 0 6.32 0 15.17 6.32 15.17 6.32 6.32 15.17 6.32 15.17 0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-smasi-1",
    x: 17.6,
    y: 0,
    width: 6.32,
    height: 24.03
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartsignalsPicturemark);
export default __webpack_public_path__ + "static/media/smartsignals_Picturemark.d5179299bab3d25c55564f181517f8ba.svg";
export { ForwardRef as ReactComponent };